import { render, staticRenderFns } from "./MoveCatalog.vue?vue&type=template&id=53580437&scoped=true"
import script from "./MoveCatalog.vue?vue&type=script&lang=js"
export * from "./MoveCatalog.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./MoveCatalog.vue?vue&type=style&index=1&id=53580437&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53580437",
  null
  
)

export default component.exports